import { Avatar, type AvatarSize } from "@design-system/Avatar/Avatar";
import { KickLogo } from "@design-system/KickLogo/KickLogo";

interface KickAvatarProps {
    size?: AvatarSize;
    className?: string;
    /** Set when "Kick" is visible next to the avatar. */
    "aria-hidden"?: boolean;
}

/**
 * The Kick bot's avatar (round Kick logo), for actions Kick took: created
 * tasks, automated edits, chat replies.
 */
export const KickAvatar = ({
    size,
    className,
    "aria-hidden": isAriaHidden,
}: Readonly<KickAvatarProps>) => (
    <Avatar
        name="Kick"
        fallback={<KickLogo variant="icon" shape="circle" />}
        size={size}
        className={className}
        aria-hidden={isAriaHidden}
    />
);
